// extracted by mini-css-extract-plugin
export default {"container":"IndexDetailsDialog-module__container--Mf2Ga","header":"IndexDetailsDialog-module__header--jzcVN","headerSubtext":"IndexDetailsDialog-module__headerSubtext--Ix6_o"};